import script from "./CartView.vue?vue&type=script&setup=true&lang=js"
export * from "./CartView.vue?vue&type=script&setup=true&lang=js"

import "./CartView.vue?vue&type=style&index=0&id=8dfcbdc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dfcbdc0"]])

export default __exports__